import Swiper from "swiper";
import { Navigation, Autoplay } from "swiper/modules";

const initialize = () => {
  const swiper = new Swiper(".gd-section-top-hero-swiper .gd-swiper", {
    modules: [Navigation, Autoplay],
    loop: true,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    initialSlide: 1,
    centeredSlides: true,
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      1280: {
        slidesPerView: 1.05,
      },
    },
    // navigation: {
    //   nextEl: ".gd-product-images .gd-swiper .swiper-button-next",
    //   prevEl: ".gd-product-images .gd-swiper .swiper-button-prev",
    // },
  });
};

document.addEventListener("DOMContentLoaded", () => {
  if (window.gd.template != "index") {
    return;
  }
  initialize();
});
